import { HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiFacadeService } from '@app/services/api-facade.service';
import { IPotentialSavingsSteadyStateDTO } from '@modules/potential-save-modal/dto/i-potential-savings-steady-state.dto';
import {
	ICalculatePotentialSavingsParamsDTO,
	IPotentialSavingsDTO,
} from '@modules/potential-save-modal/dto/i-potential-savings.dto';
import { Observable } from 'rxjs';

// @Todo: do we need root provider here?
@Injectable({
	providedIn: 'root',
})
export class PotentialSavingsApiService {
	private readonly EDP_STRATEGY_ID = '632501bbf774eb072b85fc026669507a';
	private readonly NON_EDP_STRATEGY_ID = '4efbce1053b6f97e204116a21ee6cf7f';

	constructor(private apiFacade: ApiFacadeService) {}

	public getPotentialSavings(isEDP: boolean | null): Observable<HttpResponse<IPotentialSavingsDTO>> {
		const url = `potential-savings-v2/ec2-potential-savings`;
		if (isEDP === null) {
			return this.apiFacade.getFullResponse<IPotentialSavingsDTO>(url);
		}

		const strategyID = isEDP ? this.EDP_STRATEGY_ID : this.NON_EDP_STRATEGY_ID;
		const params = new HttpParams().append('strategy_id', strategyID);

		return this.apiFacade.getFullResponse<IPotentialSavingsDTO>(url, { params });
	}

	public executePotentialSavingsByStrategy(isEDP: boolean): Observable<any> {
		const strategyID = isEDP ? this.EDP_STRATEGY_ID : this.NON_EDP_STRATEGY_ID;
		const url = `potential-savings-v2/strategies/execute_strategy/${strategyID}`;

		return this.apiFacade.post(url);
	}

	/**
	 * Trigger re-calculation potential savings with EDP strategy ID.
	 * @param {ICalculatePotentialSavingsParamsDTO} params
	 */
	public getPotentialSavingsByParams(
		params: ICalculatePotentialSavingsParamsDTO,
	): Observable<Partial<IPotentialSavingsDTO>> {
		const strategyID = this.EDP_STRATEGY_ID;
		const url = `potential-savings-v2/calculate_ps_from_params/${strategyID}`;

		return this.apiFacade.post<Partial<IPotentialSavingsDTO>>(url, params);
	}

	public getLinuxSteadyState(): Observable<IPotentialSavingsSteadyStateDTO> {
		const url = 'potential-savings-v2/linux-steady-state-graph';

		return this.apiFacade.get<IPotentialSavingsSteadyStateDTO>(url);
	}
}
